// v2-specific: this redesign's desktop Figma frames are 1320px, wider than the old
// page's MAX_CONTENT_WIDTH (screens/Investors/HomePage/const.ts, 1224px) — don't conflate the two.
export const MAX_CONTENT_WIDTH = 1320;
